export default function updateSearchParams(
  params: Record<string, any> | null,
  append?: boolean
) {
  let newUrl = window.location.pathname

  if (params !== null) {
    let searchParams: URLSearchParams

    if (append) {
      searchParams = new URLSearchParams(window.location.search)

      for (const key in params) {
        searchParams.set(key, String(params[key]))
      }
    } else {
      searchParams = new URLSearchParams(params)
    }

    if (searchParams.size > 0) {
      newUrl += `?${searchParams.toString()}`
    }
  }

  window.history.replaceState(null, '', newUrl)
}
